'use strict';
angular.module('components.directive', [
    'imgEditorCanvasModule', // 图片编辑器
]);
